<template>
  <div>
    <h2 class="text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6">
      Our Story
    </h2>
    <div class="pl-5">
      <h3 v-if="!hasCompleted" class="text-n-gray-dark text-2xl font-hairline">
        Share your story with your audience to help them get to know you and how you can help address needs they care about.
      </h3>
      <div v-else class="text-n-gray-dark text-lg leading-org_edit_content font-hairline" v-html="content" />
    </div>

    <div class="mt-6">
      <EventEditBtn :completed="hasCompleted" @click="modalOpen = true">
        Add your story
      </EventEditBtn>
    </div>
    <OrganizationStoryModal v-model="modalOpen" />
  </div>
</template>

<script>
import OrganizationStoryModal from "./modals/OrganizationStoryModal.vue";
import PencilIcon from "../../../icons/PencilIcon.vue";
import EventEditBtn from "../event/EventEditBtn.vue";
import {nl2br} from "../../../../helpers/nl2br";
export default {
  name: "OrganizationStory",
  components: {EventEditBtn, PencilIcon, OrganizationStoryModal},
  props: {
    organization: {
      required: true,
      type: Object
    },
    hasCompleted: {
      required: true,
      type: Boolean
    },
  },
  computed: {
    content() {
      return nl2br(this.organization.story);
    }
  },
  data() {
    return {
      modalOpen: false
    }
  },
}
</script>

<style scoped>

</style>